import { render, staticRenderFns } from "./Wp_tb_my_child_num_income.vue?vue&type=template&id=1ca657fe&scoped=true&"
import script from "./Wp_tb_my_child_num_income.vue?vue&type=script&lang=js&"
export * from "./Wp_tb_my_child_num_income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca657fe",
  null
  
)

export default component.exports